import { extend, getResolution, playerGetCookie, playerSetCookie, getBrowser, getOs } from './util';
import bowser from 'bowser';

/**
 * 统计模块
 * Stat module
 * @module video/Stat
 */
class Stat {
    /**
     * Creates an instance of Stat.
     * @param {object} playermsg
     */
    constructor(playermsg) {
        this.playermsg = playermsg;
        this.init(playermsg);
    }

    /**
     * 随机唯一uid
     *
     * @returns {string} 随机唯一uid
     */
    getRandomUid() {
        let tn = new Date().getTime() + (Math.round((1 << 12) * Math.random()) << 24);
        const sn = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZXX';
        let uuid = '';

        const fn1 = sn.charAt(parseInt(tn & 63));

        tn >>= 6;
        const fn2 = sn.charAt(parseInt(tn & 63));

        tn >>= 6;
        const fn3 = sn.charAt(parseInt(tn & 63));

        tn >>= 6;
        const fn4 = sn.charAt(parseInt(tn & 63));

        tn >>= 6;
        const fn5 = sn.charAt(parseInt(tn & 63));

        tn >>= 6;
        const fn6 = sn.charAt(parseInt(tn & 63));

        uuid += fn6 + fn5 + fn4 + fn3 + fn2 + fn1;

        return uuid;
    }

    /**
     * 创建随机数
     *
     * @returns {number} 随机数
     */
    static createNum() {
        const min = 1;
        const max = 10000;
        let outNum = 0;
        const randomNum = Math.random() * (max - min) + min;

        if (randomNum >= 1 && randomNum <= 1000) {
            /**
             * 随机数在0-1000内才发送统计
             */
            outNum = 1;
        } else {
            outNum = 0;
        }

        return outNum;
    }

    /**
     * 初始化
     *
     * @param {object} playermsg
     */
    init(playermsg) {
        this.initParams(playermsg);
    }

    /**
     * 初始化参数
     *
     * @param {object} playermsg
     */
    initParams(playermsg) {
        /**
         * 屏蔽统计，默认为false
         */
        this.disableSendState = playermsg.disableSendState || false;
        /**
         * 发送vv统计
         */
        this.mediaurl = '//stadig.ifeng.com/media.js';

        /**
         * 发送抽样统计
         */
        this.playerurl = '//stadig.ifeng.com/vplayer.js';

        /**
         * 播放次数
         */
        this.accumulator = '//survey.news.ifeng.com/accumulator.php';

        this.gid = window.gid;

        const defautlParams = this.formatmsg(playermsg);
        const mediaParams = this.formatMediamsg(playermsg);

        this.mediaParams = extend(defautlParams, mediaParams);
        this.restore();

        const vplayerParams = this.formatPlayermsg(playermsg);

        this.playerParams = extend(defautlParams, vplayerParams);

        const adParams = this.formatAdmsg(playermsg);

        this.adParams = extend(defautlParams, adParams);
    }

    sendMedia(url) {
        if (this.disableSendState) {
            return;
        }
        const flag = `is_${url}_send`;

        if (this[flag] === true) {
            return;
        }
        this[flag] = true;

        const newparams = extend(this.mediaParams, {
            url,
            tm: new Date().getTime(),
        });
        const params = [];

        for (const key in newparams) {
            params.push(`${key}=${encodeURIComponent(newparams[key])}`);
        }

        const scriptDom = document.createElement('script');

        scriptDom.src = `${this.mediaurl}?${params.join('&')}`;
        document.getElementsByTagName('head')[0].appendChild(scriptDom);

        if (url === 'vv' && this?.playermsg?.guid) {
            // vv时发送播放数累加accumulator
            const _scriptDom = document.createElement('script');

            _scriptDom.src = `${this.accumulator}?key=${this.playermsg.guid}&tm=${new Date().getTime()}`;
            document.getElementsByTagName('head')[0].appendChild(_scriptDom);
        }
    }

    sendVplayer(obj) {
        if (this.disableSendState) {
            return;
        }
        let vdocumentFlag = false;

        if (this.playermsg.categoryId) {
            const ptype = this.playermsg.categoryId.split('-')[0];

            if (ptype === '154') {
                vdocumentFlag = true;
            }
        }

        if (window.randomNum === 0 && !vdocumentFlag) {
            // 0:抽样统计的随机数不在0-1000之间，不发送统计;1:随机数在0-1000之间，才发送统计
            return;
        }

        let newparams = this.formatPlayermsg(obj);

        newparams = extend(this.playerParams, newparams);
        if (obj === 100000) {
            const lan = window.navigator.language || '';
            const _screen = getResolution();
            const systemInfo = `${getOs()}$false$${lan}$${1}$${_screen.screenW}$${_screen.screenH}`;

            newparams.systemInfo = systemInfo;
        }
        newparams.gid = window.gid || '';
        newparams.url = window.srcVideoUrl || '';
        newparams.tm = new Date().getTime();
        newparams.err = obj;
        const params = [];

        for (const key in newparams) {
            params.push(`${key}=${encodeURIComponent(newparams[key])}`);
        }

        const scriptDom = document.createElement('script');

        scriptDom.src = `${this.playerurl}?${params.join('&')}`;
        document.getElementsByTagName('head')[0].appendChild(scriptDom);
    }

    sendAd(url, type, data = new Object(), ind) {
        let newparams = extend(this.adParams, {
            url,
            atype: type,
            tm: new Date().getTime(),
        });

        if (url === 'request') {
            // 请求时，把所有广告信息发送
            const _time = data.oneadTime ? data.oneadTime.join('|') : '';

            const _aid = data.adUrl ? data.adUrl.join('|') : data.materiaUrl || '';

            newparams = extend(newparams, {
                snapid: '',
                adur: _time,
                aid: _aid,
            });
        } else {
            const _time = data.oneadTime ? data.oneadTime[ind] : '';
            const _aid = data.adUrl ? data.adUrl[ind] : data.materiaUrl || '';

            newparams = extend(newparams, {
                snapid: '',
                adur: _time,
                aid: _aid,
            });
        }
        const params = [];

        for (const key in newparams) {
            params.push(`${key}=${encodeURIComponent(newparams[key])}`);
        }
        const scriptDom = document.createElement('script');

        scriptDom.src = `${this.adplayerurl}?${params.join('&')}`;
        document.getElementsByTagName('head')[0].appendChild(scriptDom);
    }

    changeParams(playermsg) {
        const newParams = this.formatMediamsg(playermsg);

        this.params = extend(this.params, newParams);
        this.restore();
    }

    restore() {
        this.is_vv_send = false;
        this.is_cv_send = false;
    }

    /**
     * 格式化playermsg
     *
     * @param {object} playermsg
     * @returns {object} 格式化后的数据
     */
    formatmsg(playermsg) {
        let userid = null;

        if (playerGetCookie('userid') === '') {
            userid = this.getRandomUid();
            playerSetCookie('userid', userid, {
                domain: '.ifeng.com',
                path: '/',
                expires: 60 * 24 * 360,
            });
        } else {
            userid = playerGetCookie('userid');
        }

        const cid = typeof playermsg.categoryId !== 'undefined' ? playermsg.categoryId : '';
        const vid = 'vHTML5Player_v2.0.0';
        const cname = playermsg.columnName;

        let from = 'v_Free';
        let ptype = '';
        let loc = '';

        if (cid !== '') {
            ptype = cid.split('-')[0];
            if (ptype === '154') {
                from = 'v_Doc';
            } else if (ptype === '171') {
                from = 'v_Biz';
            } else {
                from = 'v_Free';
            }
        }

        // @todo 这个地方使用了外部的约定设备校验，不是很好，回头是否要封装一个方法？
        if (typeof window.device !== 'undefined' && typeof window.device.type !== 'undefined') {
            loc = window.device.type;
        }

        const bowserInfo = bowser.getParser(window.navigator.userAgent);
        let bowserOS = {};
        const screenResolve = `${window ? `${window.screen.width}*${window.screen.height}` : ''}`;

        if (bowserInfo.getOS) {
            bowserOS = bowserInfo.getOS();
            if (typeof bowserOS.name === 'undefined') {
                bowserOS = {
                    name: 'unknown',
                    version: '',
                };
            }
        }

        return {
            id: playermsg.guid,
            sid: playerGetCookie('sid'),
            uid: userid,
            from,
            vid,
            provider: playermsg.CPId || '',
            dur: playermsg.duration,
            se: typeof cname !== 'undefined' ? cname : cid,
            cat: cid,
            ptype,
            systemInfo: `${(bowserOS.name && bowserOS.name.toLowerCase()) || ''},${bowserOS.name}_${bowserOS.version},${
                bowserInfo.getBrowserName ? bowserInfo.getBrowserName() : ''
            },${screenResolve}`,
            ref: window.location.href,
            loc,
            snapid: 'wapifeng',
        };
    }

    formatMediamsg(playermsg) {
        const cid = typeof playermsg.categoryId !== 'undefined' ? playermsg.categoryId : '';

        return {
            cat: cid,
            provider: playermsg.CPId || '',
        };
    }

    formatPlayermsg(playermsg) {
        const url = typeof playermsg.src !== 'undefined' ? `${playermsg.src}?gid=${this.gid}` : '';
        const br = typeof playermsg.br !== 'undefined' ? playermsg.br : '';
        const err = typeof playermsg.err !== 'undefined' ? playermsg.err : '';

        const obj = {};

        obj.gid = this.gid;
        if (url !== '') obj.url = url;
        if (br !== '') obj.br = br;
        if (err !== '') obj.err = err;

        return obj;
    }

    formatAdmsg(playermsg) {
        const cid = typeof playermsg.categoryId !== 'undefined' ? playermsg.categoryId : '';
        const _browser = getBrowser();
        const _screen = getResolution();
        const systemInfo = `PC,${getOs()},${_browser.type}_${_browser.version},${_screen.screenW}*${_screen.screenH}`;

        return {
            cat: cid,
            provider: playermsg.CPId || '',
            systemInfo,
        };
    }
}

const randomNum = Stat.createNum();

export { Stat, randomNum };
